export default __webpack_public_path__ + "static/media/Artboard – 2.d8683ce3.png";